const trackingParams = []
export default trackingParams;